/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { EmissionsExclusions } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function EmissionsExclusionsUpdateForm(props) {
  const {
    id: idProp,
    emissionsExclusions: emissionsExclusionsModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    ExcludedSource: "",
    JustificationForExclusion: "",
  };
  const [ExcludedSource, setExcludedSource] = React.useState(
    initialValues.ExcludedSource
  );
  const [JustificationForExclusion, setJustificationForExclusion] =
    React.useState(initialValues.JustificationForExclusion);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = emissionsExclusionsRecord
      ? { ...initialValues, ...emissionsExclusionsRecord }
      : initialValues;
    setExcludedSource(cleanValues.ExcludedSource);
    setJustificationForExclusion(cleanValues.JustificationForExclusion);
    setErrors({});
  };
  const [emissionsExclusionsRecord, setEmissionsExclusionsRecord] =
    React.useState(emissionsExclusionsModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(EmissionsExclusions, idProp)
        : emissionsExclusionsModelProp;
      setEmissionsExclusionsRecord(record);
    };
    queryData();
  }, [idProp, emissionsExclusionsModelProp]);
  React.useEffect(resetStateValues, [emissionsExclusionsRecord]);
  const validations = {
    ExcludedSource: [],
    JustificationForExclusion: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          ExcludedSource,
          JustificationForExclusion,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            EmissionsExclusions.copyOf(emissionsExclusionsRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "EmissionsExclusionsUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Emissions Exclusions"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 24d."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Create this record that describes exclusions of emissions sources, including facilities, operations or assets, and a justification for why they were excluded."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Excluded emission source"
        isRequired={false}
        isReadOnly={false}
        value={ExcludedSource}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ExcludedSource: value,
              JustificationForExclusion,
            };
            const result = onChange(modelFields);
            value = result?.ExcludedSource ?? value;
          }
          if (errors.ExcludedSource?.hasError) {
            runValidationTasks("ExcludedSource", value);
          }
          setExcludedSource(value);
        }}
        onBlur={() => runValidationTasks("ExcludedSource", ExcludedSource)}
        errorMessage={errors.ExcludedSource?.errorMessage}
        hasError={errors.ExcludedSource?.hasError}
        {...getOverrideProps(overrides, "ExcludedSource")}
      ></TextField>
      <TextAreaField
        label="Justification for exclusion"
        isRequired={false}
        isReadOnly={false}
        value={JustificationForExclusion}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ExcludedSource,
              JustificationForExclusion: value,
            };
            const result = onChange(modelFields);
            value = result?.JustificationForExclusion ?? value;
          }
          if (errors.JustificationForExclusion?.hasError) {
            runValidationTasks("JustificationForExclusion", value);
          }
          setJustificationForExclusion(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "JustificationForExclusion",
            JustificationForExclusion
          )
        }
        errorMessage={errors.JustificationForExclusion?.errorMessage}
        hasError={errors.JustificationForExclusion?.hasError}
        {...getOverrideProps(overrides, "JustificationForExclusion")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || emissionsExclusionsModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || emissionsExclusionsModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
